export const securedUrls = {
  getSHPConsentURL: '/mas/sec/getSHPConsent.json',
  updateSHPConsentURL: '/mas/sec/updateSHPConsent.json',

  getMemberAccountDetailsURL: '/mas/sec/getMemberAccountDetails.json',
  getMemberDedOopNetworkAccumsURL: '/mas/sec/getMemberDedOopNetworkAccums.json',
  getMedicalServiceTypeCategoriesURL: '/mas/sec/getMedicalServiceTypeCategories.json',
  getBenefitsMemberOptionsURL: '/mas/sec/getBenefitsMemberOptions.json',
  getMedicalServiceTypeDetailsURL: '/mas/sec/getMedicalServiceTypeDetails.json',
  getMemberMedicalBenefitDetailsURL: '/mas/sec/getMemberMedicalBenefitDetails.json',
  getNascoMedicalBenefitsURL: '/mas/sec/getNascoMedicalBenefits.json',
  viewDentalBenefitsURL: '/mas/sec/viewDentalBenefit.pdf',
  getInvoiceDetailsURL: '/mbps/sec/ebill/getInvoiceDetails.json',
  getCurrentInvoicesURL: '/mbps/sec/ebill/getCurrentInvoices.json',
  getPaymentMethodURL: '/mbps/sec/ebill/listPaymentMethods.json',
  getPaymentDetailswithReceiptURL: '/mbps/sec/ebill/listPaymentDetailswithReceipt.json',
  getInvoiceHistoryURL: '/mbps/sec/ebill/getInvoiceHistory.json',
  addPaymentMethodURL: '/mbps/sec/ebill/addPaymentMethod.json',
  updatePaymentMethodURL: '/mbps/sec/ebill/updatePaymentMethod.json',
  cancelPaymentDetailsURL: '/mbps/sec/ebill/cancelPaymentDetails.json',
  getMemberCommunicationURL: '/mas/sec/getMemberCommunicationInfo.json',
  viewPaymentHistoryDetailsExcelURL: '/mbps/sec/ebill/viewPaymentHistoryDetails.xls',
  getInvoiceDetailPdfURL: '/mbps/sec/ebill/viewInvoiceDetails.pdf',
  updatePaymentDetailsURL: '/mbps/sec/ebill/updatePaymentDetails.json',
  addPaymentDetailsURL: '/mbps/sec/ebill/addPaymentDetails.json',
  registerPCITokenURL: '/mas/sec/addMemberBillPayerToken.json',
  deletePaymentMethodURL: '/mbps/sec/ebill/deletePaymentMethod.json',
  disablePaymentMethodsURL: '/mbps/sec/ebill/disablePaymentMethods.json',
  contactusfetchdetailsURL: '/mas/sec/getContactUsDetails.json',
  scheduledCallDetailsURL: '/mas/sec/getScheduledCallDetails.json',
  memberContractsURL: '/mas/sec/searchMemberContracts.json',
  viewContractURL: '/mas/sec/viewMemberContracts.pdf',
  analyticsDetailsURL: '/mas/sec/getMemberAnalyticsDetails.json',
  getCVSDrugComponentLinkURL: '/mas/sec/getCVSDrugComponentLink.json',
  searchDocumentsURL: '/mas/sec/searchMemberDocuments.json',
  viewDocumentURL: '/mas/sec/viewMemberDocument.pdf',
  preferredDrugURL: '/mas/sec/getPreferredDrugListUrl.json',
  getMembersForChangePCPURL: '/mas/sec/getMembersForChangePCP.json',
  getFAPMemberProviderPlansURL: '/mas/sec/getFAPMemberProviderPlans.json',
  getFAPGlobalFlagsURL: '/mas/sec/getFAPGlobalFlags.json',
  postChangePCPURL: '/mas/sec/changePCP.json',
  getAppleWalletIdcardDataURL: '/mas/sec/getMemberPassKeys.json',
  appleWalletRequestURL: '/mas/sec/getMemberPass.do?',
  getIDCardMemberOptionsDataURL: '/mas/sec/getIDCardMemberOptions.json',
  orderMemberIdCardsURL: '/mas/sec/orderMemberIdCards.json',
  orderMemberIdCardsErrorURL: '/mas/sec/orderMemberIdCardsError.json',
  userSecurityImageSecuredURL: '/mas/sec/getCachedBinaryResource.do?id=',
  getMemberIdCardsURL: '/mas/sec/getMemberIdCards.json',
  getExperianLinksURL: '/mas/sec/getExperianLinks.json',
  getOngoingTransactionsURL: '/mas/sec/enrl/getOngoingTransactions.json',
  getcobraContractDetailsURL: '/mas/sec/enrl/getCobraContractDetails.json',
  planSummaryURL: '/mas/sec/getMemberPlanSummary.json',
  inNetworkMemberGeneralBenefitsURL: '/mas/sec/getInNetworkMemberGeneralBenefits.json',
  memberPcpDetailsURL: '/mas/sec/getMemberPcpDetails.json',
  searchMemberClaimsURL: '/mas/sec/searchMemberClaims.json',
  getBlueRewardsMemberURL: '/mas/sec/getBlueRewardsMemberInfo.json',
  getMemberQualifierDetailsUrl: '/mas/sec/getMemberQualifierDetails.json',
  updateBlueRewardsMemberInfo: '/mas/sec/updateBlueRewardsMemberInfo.json',
  getBillSummaryURL: '/mbps/sec/ebill/getBillSummary.json',
  getPromotionalAlertsURL: '/mas/sec/getPromotionalAlerts.json',
  downloadMhrinfo: '/mas/sec/downloadBlueButtonDocument.do',
  getAlertsURL: '/mas/sec/getAlerts.json',
  updateAlertURL: '/mas/sec/updateAlert.json',
  setDoNotShowWellnessAlertMemberPreferenceURL: '/mas/sec/setDoNotShowWellnessAlertMemberPreference.json',
  logoutURL: '/mas/sec/logout.json',
  oktaLogoutURL:'/logoutshop',
  getCareSelectSSOURL: '/mas/sec/getCareSelectSSOLink.json',
  getMemberOutofPockectLinkURL: '/mas/sec/getMemberOutOfPocketToolLink.json',
  getSecureMessagesURL: '/mas/sec/getSecureMessages.json',
  viewSecureMessageURL: '/mas/sec/viewSecureMessage.json',
  viewAttachmentURL: '/mas/sec/viewAttachment.do',
  getUnreadMessageCountURL: '/mas/sec/getUnreadMessageCount.json',
  updateSecureMessagesURL: '/mas/sec/updateSecureMessages.json',
  getAlertCountURL: '/mas/sec/getAlertCount.json',
  getSecurityQuestURL: '/mas/sec/getSecurityQuestions.json',
  updateMemberCommunicationInfoURL: '/mas/sec/updateMemberCommunicationInfo.json',
  changeSecurityQuesURL: '/mas/sec/changeSecurityQuestions.json',
  getSecurityImageURL: '/mas/sec/getSiteKeyImages.json',
  showSSOSecurityImageURL: '/mas/sec/getUserSiteKeyDetails.json',
  updateSiteKeyDetailsURL: '/mas/sec/updateUserSiteKeyDetails.json',
  getWellnessReminderURL: '/mas/sec/getMemberPreferences.json',
  getMemberContactDetailsURL: '/mas/sec/getMemberContactDetails.json',
  updateSubscriberContactNumberURL: '/mas/sec/updateSubscriberContactNumber.json',
  updateSubscriberAddressURL: '/mas/sec/updateSubscriberAddress.json',
  validatePasswordURL: '/mas/sec/validatePassword.json',
  getMemberRELICCDetailsURL: '/mas/sec/getMemberRELICCDetails.json',
  getRELICCCodeAndDescriptionURL: '/mas/sec/getRELICCCodeAndDescription.json',
  updateMemberReliccDetailsURL: '/mas/sec/updateMemberRELICCDetails.json',
  getMemberAddressDetailsURL: '/mas/sec/getMemberAddressDetails.json',
  updateProfilePictureURL: '/mas/sec/updateUserRecordAttachment.json',
  getProfilePictureURL: '/mas/sec/getUserRecordAttachment.json',
  deleteProfilePictureURL: '/mas/sec/deleteUserRecordAttachment.json',
  getMemberOptionsURL: '/mas/sec/getOCSMemberOptions.json',
  getSavedSubmittedClaimsURL: '/mas/sec/getOCSSavedSubmittedClaims.json',
  postSaveOCSClaimDetailsURL: '/mas/sec/saveOCSClaimDetails.json',
  postUploadOCSClaimAttachmentURL: '/mas/sec/uploadOCSClaimAttachment.json',
  postDeleteClaimURL: '/mas/sec/deleteOCSClaimDetails.json',
  getOCSCodesandDescriptionsURL: '/mas/sec/getOCSCodesandDescriptions.json',
  getOCSClaimDetailsURL: '/mas/sec/getOCSClaimDetails.json',
  viewOCSDocumentURL: '/mas/sec/viewOCSDocument.do',
  getMemberCobDetailsURL: '/mas/sec/getMemberCobDetails.json',
  updateCOBInfoURL: '/mas/sec/updateCOBInfo.json',
  addDependentURL: '/mas/sec/addDependent.json',
  memberDetailsURL: '/mas/sec/getCurrentMemberOptions.json',
  changePasswordSecurityURL: '/mas/sec/changePassword.json',
  getAlertListURL: '/mas/sec/getListAlert.json',
  sendSecureMessageURL: '/mas/sec/sendSecureMessage.json',
  fetchMemberDetailsURL: '/mas/sec/getOnlineChatDetails.json',
  confirmPhoneNumberURL: '/mas/sec/confirmPhoneNumber.json',
  reSendPhoneActivationCodeURL: '/mas/sec/reSendPhoneActivationCode.json',
  reSendEmailActivationCodeURL: '/mas/sec/reSendEmailActivationCode.json',
  getMemberEligibilityDetailsURL: '/mas/sec/getMemberEligibilityDetails.json',
  postRemoveDependentURL: '/mas/sec/removeDependent.json',
  availableTimeSlotsURL: '/mas/sec/getAvailableTimeSlots.json',
  scheduleRequestURL: '/mas/sec/scheduleCall.json',
  rescheduleRequestURL: '/mas/sec/reScheduleCall.json',
  callCancelURL: '/mas/sec/cancelCall.json',
  getUnsubscribeTypeURL: '/mas/pub/getUnsubscribeType.json',
  updateUnsubscribeConsentURL: '/mas/pub/updateUnsubscribeConsent.json',
  getMemberTINDetailsURL: '/mas/sec/getMemberTINDetails.json',
  getTINFormListURL: '/mas/sec/getTINFormList.json',
  isValidTINURL: '/mas/sec/isValidTIN.json',
  updateTINDetailsURL: '/mas/sec/updateMemberTINDetails.json',
  viewTINFormURL: '/mas/sec/viewTINForm.pdf',
  getSBCURL: '/mas/sec/getSBCLink.json',
  getActivityFeedURL: '/mas/sec/getActivityFeed.json',
  fetchFADMemberDetailsUrl: '/mas/sec/getFADOnlineChatDetails.json',
  // for claim summary
  getFinancialSummary: '/mas/finsum/getClaimSummary.json',
  getCareSelectLinkUrl: '/mas/sec/getCareSelectLink.json',
  getHospiceCOBAlertApplicable: '/mas/sec/hospiceCOBAlertApplicable.json',
  insertDeferredPaymentDurationDetailsURL: '/mas/sec/insertDeferredPaymentDurationDetails.json',
  getDeferralMemberDetailsURL: '/mas/sec/getDeferralMemberDetails.json',
  updateMemberEmailOrPhoneInfoURL: '/mas/sec/updateMemberEmailOrPhoneInfo.json'
};



// WEBPACK FOOTER //
// ./src/environments/urls/secured-urls.ts